import { configType } from "./environmentConfigs/configTypes"

const configs: configType = {
  apiKey: "b92307c2-1a60-4d4b-b1fe-4d3ba57d1ca5",
  logLevel: 1,
  environmentLevel: "GAMMASANBOX",
}
export default configs
